
import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';

import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { HealthInsureSettingPanelController } from './HealthInsureSettingPanelController';
import { PopoverAlertComponent } from 'src/app/View/Common/Popover/Alert/PopoverAlertComponent';
import { HealthInsurePopupComponent } from './HealthInsurePopup/HealthInsurePopupComponent';



/**
 * HealthInsureSettingPanelComponent
 * 保険証アップロード画面
 */
@Component({
	selector: 'app-mypage-component',
	templateUrl: './HealthInsureSettingPanelComponent.html',
	styleUrls: ['./HealthInsureSettingPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class HealthInsureSettingPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: HealthInsureSettingPanelController;

	// ジェスチャー対象のElement参照
	@ViewChild('gesturePage', { read: ElementRef, static: false }) gesturePage: ElementRef;
	@ViewChild('frontFileInput') frontFileInput;
	@ViewChild('backFileInput') backFileInput;

	// 保険証が存在するかのフラグ
	public isExistInsure = false;
	// 削除データのターゲット
	public deleteTargetData: any;

	// 取得した保険証データをいれる
	public bindData: any = {};


	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public renderer: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		this.createController(HealthInsureSettingPanelController);
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// 保険証を取得して、存在しなければfalseとする
		const ret = await this.getHealthInsureData();
		this.bindData = ret;

		this.log(this.isExistInsure);

		// スライドイン表示は自分でやる
		await this.slideIn();
		// ジェスチャーを与える対象を設定する
		this.setGestureTargetElementRef(this.gesturePage);

	}


	/**
	 * getHealthInsureData
	 * アップロード済みの保険証データを取得する
	 * @returns 保険証簡易データ
	 */
	public async getHealthInsureData() {

		// 保存されているDB上の保険証データを取得
		const ret: Array<any> = await this.execUserFuncWithErrorHandling(
			this,
			this.combineCtrl.getHealthInsureData.bind(this),
			{ view: this }
		);
		this.log(ret);
		// 失敗時はfalse
		if (!Object.keys(ret).length) {
			this.isExistInsure = false;
			return;
		}

		this.isExistInsure = true;
		return ret;

	}

	/**
	 * sendHealthInsureData
	 * 保険証データを送信する
	 * @param fileList 送信ファイルデータ
	 */
	public async sendHealthInsureData(fileList: any) {

		// ファイルデータを送信する
		const ret = await this.execUserFuncWithErrorHandling(
			this,
			this.combineCtrl.sendHealthInsureData.bind(this),
			{ view: this, fileData: fileList }
		);
		this.log(ret);

		// 送信後にアップロード済みデータを再取得して、再設定する
		const obj = await this.getHealthInsureData();
		this.bindData = obj;

		// 先にダイアログを閉じる
		await this.dismissDialogWindow();

	}


	/**
	 * acceptDeleteHealthInsureData
	 * 保険証削除の実行
	 * @param ret 保険証削除の実行可否
	 * @returns void
	 */
	public async acceptDeleteHealthInsureData(ret: boolean) {

		// 削除実行をキャンセルした場合
		if (!ret) {
			// ダイアログを閉じる
			await this.dismissDialogWindow();
			return;
		}

		// 引数がtrueで帰ってきた場合は承認とする
		if (ret) {
			// 削除実行
			await this.execUserFuncWithErrorHandling(
				this,
				this.combineCtrl.deleteHealthInsureData.bind(this),
				{ view: this, healthInsureData: this.bindData }
			);
			// 再取得した保険証リストを設定する
			this.bindData = await this.getHealthInsureData();
		}

		this.deleteTargetData = null;

		// ダイアログを閉じる
		await this.dismissDialogWindow();

	}






	//////////////////////////////////////
	// 画面イベント
	// 新規アップロード
	public async onClickUploadHealthInsure(side: number) {

		// ポップアップの表示
		await this.showDialogWindow(
			HealthInsurePopupComponent,
			{
				side,
				success: this.sendHealthInsureData.bind(this),
				close: this.dismissDialogWindow.bind(this)
			}
		);

	}

	/**
	 * onClickChangeHealthInsure
	 * アップロードファイル変更イベント
	 * @param isFront 表側かどうか
	 */
	public async onClickChangeHealthInsure(isFront: boolean) {
		// ファイル選択Inputのイベントを発火する
		if (isFront) {
			this.frontFileInput.nativeElement.click();
		} else {
			this.backFileInput.nativeElement.click();
		}

	}

	/**
	 * onChangeFileInput
	 * ファイル選択
	 * @param orgData ファイルの簡易データ
	 * @param isFront 表側かどうか
	 */
	public async onChangeFileInput(orgData: any, isFront: boolean) {

		// 送信する入力を選択する
		const fileInput = isFront ? this.frontFileInput : this.backFileInput;
		// ファイル送信
		const ret = await this.execUserFuncWithErrorHandling(
			this,
			this.combineCtrl.changeHealthInsureData.bind(this),
			{ view: this, fileInfoId: orgData.id, displayName: orgData.displayName, uploadFile: fileInput.nativeElement.files[0] }
		);

		// ファイル変更ができたら、ファイルを再取得する
		if (ret) {
			fileInput.nativeElement.value = '';
			const obj = await this.getHealthInsureData();
			this.bindData = obj;
		}

	}


	/**
	 * onClickDeleteHealthInsure
	 * アップロード済みのファイルを削除する
	 * @param data ファイル簡易データ
	 */
	public async onClickDeleteHealthInsure() {

		// 確認ポップアップの表示
		await this.showDialogWindow(
			PopoverAlertComponent,
			{
				title: '警告',
				text: '削除してもよろしいですか？',
				close: this.acceptDeleteHealthInsureData.bind(this),
			}
		);

	}

}
